import React, { createContext, useState, useContext } from 'react';

const PropertyRoomContext = createContext();

export const PropertyRoomProvider = ({ children }) => {
    const [evidenceSubPage, setEvidenceSubPage] = useState('S01_SEARCH');

    return (
        <PropertyRoomContext.Provider value={{ evidenceSubPage, setEvidenceSubPage }}>
            {children}
        </PropertyRoomContext.Provider>
    );
};

export const usePropertyRoom = () => {
    const context = useContext(PropertyRoomContext);
    // Return null if context is not available (for components outside provider)
    return context;
};
